/**
* 基础菜单 订单满减管理
*/
<template>
  <div class="contianer">
    <!-- 面包屑导航 -->
    <!-- <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>营销管理</el-breadcrumb-item>
        <el-breadcrumb-item>订单满减管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div> -->
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="">
        <el-select v-model="formInline.status" placeholder="有效类型" clearable>
          <el-option label="有效" value="1"></el-option>
          <el-option label="无效" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="formInline.full_discount_type" placeholder="满减类型" clearable>
          <el-option v-for="full_discount_type in FullDiscountType" :key="full_discount_type.code"
                     :label="full_discount_type.name"
                     :value="full_discount_type.code"></el-option>
        </el-select>

      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.brand_name" placeholder="品牌名称" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="search">查询</el-button>
        <el-button size="small" type="primary" @click="adddiscount" class="add-button">新增</el-button>
        <el-button size="small" type="primary" @click="editdiscount" class="edit-button">修改</el-button>
<!--        <el-button size="small" type="danger" @click="deldiscount">删除</el-button>-->
      </el-form-item>
    </el-form>
    <!--列表-->
    <div style="height: 530px;overflow-y: auto">
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                @cell-dblclick="cellDbClick" @selection-change="handleSelectionChange"
                :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column align="center" type="selection" width="60">
        </el-table-column>
        <el-table-column
          label="序号"
          width="60">
          <template slot-scope="scope">
            {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
          </template>
        </el-table-column>
        <el-table-column prop="full_name" label="满减名称" min-width="220" :show-overflow-tooltip='true'>

        </el-table-column>
        <el-table-column prop="full_discount_type" label="满减类型" width="100" :show-overflow-tooltip='true'>
          <!--          <template slot-scope="scope">-->
          <!--           <div v-if="scope.row.full_discount_type==1300">店铺满减</div>-->
          <!--           <div v-else-if="scope.row.full_discount_type==1301">品牌满减</div>-->
          <!--           <div></div>-->
          <!--          </template>-->
          <template slot-scope="scope">
            <div>{{Formatter(scope.row.full_discount_type)}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="brand_id" label="品牌名称" width="152" :show-overflow-tooltip='true'>
          <template slot-scope="scope">
            <div>{{FormatterBrand(scope.row.brand_id)}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="full_money" label="满减订单金额" width="120" :show-overflow-tooltip='true'>
          <template slot-scope="scope">
            <div v-if="scope.row.full_money||scope.row.full_money==0">￥{{scope.row.full_money}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="discount_money" label="优惠金额" width="120" :show-overflow-tooltip='true'>
          <template slot-scope="scope">
            <div v-if="scope.row.discount_money||scope.row.discount_money==0">￥{{scope.row.discount_money}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="create_name" label="创建人" width="180" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间" width="135">
        </el-table-column>
        <el-table-column prop="end_time" label="结束时间" width="135">
        </el-table-column>
        <el-table-column prop="status" label="有效状态" width="76">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              :active-value="1"
              :inactive-value="0"
              @change="changeStatus(scope.row.id,scope.row.status)"
              active-color="#409EFF">
            </el-switch>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               :title="dialogTitle"
               :visible.sync="discountDialogVisible"
               width="30%"
               :before-close="handleClose"
               center>
      <el-form label-width="155px" :model="discountForm" :rules="discountRules" ref="discountForm" class="discountForm">
        <el-form-item label="满减名称" prop="full_name" class="relative r50">
          <el-input size="small" v-model="discountForm.full_name" auto-complete="off" clearable maxlength="100"
                    placeholder="请输入满减名称"></el-input>
        </el-form-item>
        <el-form-item label="满减类型" prop="full_discount_type">
          <el-select v-model="discountForm.full_discount_type" placeholder="请选择满减类型" clearable>
            <el-option v-for="full_discount_type in FullDiscountType" :key="full_discount_type.code"
                       :label="full_discount_type.name"
                       :value="full_discount_type.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="品牌" prop="brand_id" v-if="discountForm.full_discount_type==1301">
          <el-select v-model="discountForm.brand_id" filterable placeholder="请选择品牌名称" ref="optionRef"
                     @change="changeBrand" clearable>
            <el-option v-for="item in BrandList" :key="item.id" :label="item.name"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="满减订单金额" prop="full_money" class="relative r50">
          <el-input size="small" v-model="discountForm.full_money" auto-complete="off" clearable maxlength="8"
                    placeholder="请输入订单金额"></el-input>
        </el-form-item>
        <el-form-item label="优惠金额" prop="discount_money" class="relative r50">
          <el-input size="small" v-model="discountForm.discount_money" auto-complete="off" clearable  maxlength="8"
                    placeholder="请输入优惠金额"></el-input>
        </el-form-item>
        <el-form-item label="结束时间" prop="end_time">
          <template>
            <div class="block">
              <el-date-picker
                v-model="discountForm.end_time"
                type="datetime"
                placeholder="请选择结束时间">
              </el-date-picker>
            </div>
          </template>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button @click="resetForm('discountForm')">重 置</el-button>
            <el-button type="primary" @click="saveSort('discountForm')">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {
    discountDetail,       // 订单满减-详情
    discountUpdate,       // 订单满减-修改
    discountList,         // 订单满减-列表
    discountAdd,          // 订单满减-新增
    discountDisabled,     // 订单满减-删除-设置无效
    discountEnabled,       // 订单满减-设置有效
    productBrand,
  } from '../../api/basisMG'
  import Pagination from '../../components/Pagination'
  import {param} from '../../api/commonMG'
  import {timestampToTime} from '../../utils/util'

  export default {
    name: 'gift',
    data: () => {
      var validateNum = (rule, value, callback) => {
        if (value === '' || value == undefined || value == null) {
          return callback(new Error('请输入优惠金额'));
        } else if (!(/(^0\.[1-9]\d?$)|(^0\.\d[1-9]?$)|(^[1-9]\d{0,7}(\.\d{0,2})?$)/.test(value))) {
          return callback(new Error('输入长度过长或格式不正确'));
        } else {
          return callback();
        }
      };
      var validateSalePrice = (rule, value, callback) => {
        if (value === '' || value == undefined || value == null) {
          return callback(new Error('请输入订单金额'));
        } else if (!(/(^0\.[1-9]\d?$)|(^0\.\d[1-9]?$)|(^[1-9]\d{0,7}(\.\d{0,2})?$)/.test(value))) {
          return callback(new Error('输入长度过长或格式不正确'));
        } else {
          return callback();
        }
      };
      return {
        loading: false, //是显示加载
        discountDialogVisible: false,  // 弹窗
        dialogTitle: '',  // 标题
        FullDiscountType: [],   // 满减类型
        selectTableData: [],
        status: true,
        productId: '',
        BrandList: [],
        formInline: {
          page: 1,
          rows: 10,
          status: '',
          full_discount_type: '',
          brand_name: ''
        },
        discountRules: {
          full_name: [{required: true, message: '请输入满减名称', trigger: 'blur'}],
          full_discount_type: [{required: true, message: '请选择满减类型', trigger: 'blur'}],
          brand_id: [{required: true, message: '请选择品牌', trigger: 'blur'}],
          full_money: [{required: true, validator: validateSalePrice, trigger: 'blur'}],
          discount_money: [{required: true, validator: validateNum, trigger: 'blur'}],
          end_time: [{required: true, message: '请选择结束时间', trigger: 'blur'}],
        },
        discountForm: {
          id: '',
          full_name: '',
          full_discount_type: '',
          brand_id: '',
          brand_name: '',
          full_money: '',
          discount_money: '',
          end_time: '',
        },
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        sale_id: '',
        status: [{
          name: '是',
          value: 1
        }, {
          name: '否',
          value: 0
        }],
        full_discount_type: [],
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
    },
    mounted() {
      this.getParam('FullDiscountType')        // 满减类型
      this.getBrand()
    },
    methods: {
      // 过滤
      Formatter(value, type) {
        for (let item of this.FullDiscountType) {
          if (item.code == value) {
            return item.name
          }
        }
      },
      //获取系统字典
      getParam(type) {
        param(type)
          .then(res => {
            if (res.success) {
              if (type == 'FullDiscountType') {
                this.FullDiscountType = res.content;
              }
            }
          })
          .catch(err => {
          })
      },
      handleClick(tab, event) {
        console.log(tab, event);
      },
      /**
       * 里面的方法只有被调用才会执行
       */
      changeStatus(id, status) {
        if (!status) {
          discountDisabled(id)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'error',
                  message: '已将状态设置为无效!'
                });
                this.getdata(this.formInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        } else {
          discountEnabled(id)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '已将状态设置为有效!'
                });
                this.getdata(this.formInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }
      },
      // 新增订单满减
      adddiscount() {
        this.discountDialogVisible = true;
        this.dialogTitle = '新增订单满减';
        this.discountForm = {
          id: '',
          full_name: '',
          full_discount_type: '',
          brand_id: '',
          brand_name: '',
          full_money: '',
          discount_money: '',
          end_time: ''
        };
        productBrand('')
          .then(res => {
            if (res.success) {
              this.BrandList = res.content;
            }
          })
          .catch(err => {

          })
      },
      // 修改订单满减
      editdiscount() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        this.productId = this.selectTableData[0].id;
        this.dialogTitle = '修改订单满减';
        this.discountDialogVisible = true;
        productBrand('')
          .then(res => {
            if (res.success) {
              this.BrandList = res.content;
            }
          })
          .catch(err => {

          })
        this.discountForm.full_discount_type = this.selectTableData[0].full_discount_type;
        this.discountForm.full_money = this.selectTableData[0].full_money;
        this.discountForm.discount_money = this.selectTableData[0].discount_money;
        this.discountForm.full_name = this.selectTableData[0].full_name;
        this.discountForm.brand_id = this.selectTableData[0].brand_id;
        this.discountForm.end_time = this.selectTableData[0].end_time;
      },
      // 删除订单满减
      deldiscount() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        const title = '是否删除订单满减？？';
        this.$confirm(title, '删除订单满减', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true;
          discountDisabled(this.selectTableData[0].id)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                this.getdata(this.formInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      getBrand() {
        productBrand('')
          .then(res => {
            if (res.success) {
              this.BrandList = res.content;
            }
          })
          .catch(err => {
          })
      },
      FormatterBrand(brand_id) {
        for (let item of this.BrandList) {
          if (item.id == brand_id) {
            return item.name
          }
        }
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      // 获取公司列表
      getdata(parameter) {
        this.loading = true
        discountList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData = res.content.rows
              // 分页赋值
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.rows
              this.pageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.rows = parm.pageSize
        this.getdata(this.formInline)
      },
      // 新增订单满减保存
      saveSort(formName) {
        if (this.discountForm.full_discount_type != 1301) {
          this.discountForm.brand_name = '';
          this.discountForm.brand_id = '';
        }
        if (this.discountForm.end_time) {
          this.discountForm.end_time = timestampToTime(this.discountForm.end_time)
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            // if(Number(this.discountForm.discount_money) > Number(this.discountForm.full_name)) {
            //   this.$message({
            //     type: 'error',
            //     message: '优惠金额不能大于满减订单金额!'
            //   });
            //   return
            // }
            // if(Number(this.discountForm.discount_money) == Number(this.discountForm.full_name)) {
            //   this.$message({
            //     type: 'error',
            //     message: '满减订单金额不能相同'
            //   });
            //   return
            // }
            this.loading = true;
            if (this.dialogTitle == '新增订单满减') {
              discountAdd(this.discountForm)
                .then(res => {
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功增加订单满减!'
                    });
                    this.discountDialogVisible = false;
                    this.getdata(this.formInline)
                  }
                })
                .catch(err => {
                  this.loading = false
                  this.$message.error('网络错误，请稍后再试！')
                })
            } else {
              this.discountForm.id = this.productId;
              discountUpdate(this.discountForm)
                .then(res => {
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功修改订单满减!'
                    });
                    this.discountDialogVisible = false;
                    this.getdata(this.formInline)
                  }
                })
                .catch(err => {
                  this.loading = false
                  this.$message.error('网络错误，请稍后再试！')
                })
            }
          } else {
            console.log('error submit!!');
          }
        });
      },
      // 搜索事件
      search() {
        this.formInline.page = 1;
        this.getdata(this.formInline)
      },
      handleRemove(file) {
        console.log(file);
      },
      handleSelectionChange(val) {
        this.selectTableData = val
      },
      handleClose() {
        this.$refs["discountForm"].resetFields();
        this.discountDialogVisible = false;
      },
      changeBrand(id) {
        let selectedWorkName = {};
        selectedWorkName = this.BrandList.find((item) => {//这里的chargingWorkNameList就是上面遍历的数据源
          return item.id === id;
          //筛选出匹配数据，是对应数据的整个对象
        });
        this.discountForm.brand_name = selectedWorkName.name
      },
      //双击复制
      cellDbClick(row, column, cell, event) {
        if (row.brand_name == cell.innerText) {
          if (event.type === "dblclick") {
            var save = function (e) {
              e.clipboardData.setData('text/plain', cell.innerText);
              e.preventDefault();//阻止默认行为
            }
            document.addEventListener('copy', save);
            document.execCommand("copy");
            document.removeEventListener('copy', save);
          }
          this.$message({message: '复制成功', type: 'success'})
        }
      }
    }
  }
</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  /deep/ .user-search .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  /deep/ .user-search .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .user-search .el-button--small {
    height: 40px;
  }

  /deep/ .textarea .el-textarea__inner {
    resize: none;
  }

  /deep/ .r55 .el-input__suffix {
    right: 55px !important;
  }

  .breadcrumb {
    margin-bottom: 15px;
  }

  /deep/ .discountForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 320px;
  }

  /deep/ .discountForm .el-input {
    width: 320px;
  }

  /deep/ .discountForm .el-input--small {
    width: 320px;
  }

  /deep/ .textarea .el-textarea__inner {
    resize: none;
  }

  /deep/ .discountForm .el-form-item__label {
    position: relative;
    padding: 0 22px 0 0 !important;
  }

  /deep/ .discountForm .el-select-dropdown__list {
    padding-bottom: 50px;
    min-height: 150px;
  }

  /deep/ .discountForm .el-select-dropdown__item {
    width: 320px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  /deep/ .discountForm .el-input--small {
    width: 320px;
  }

  .add-button {
    background: #53B03C;
    border-color: #53B03C;
  }

  .edit-button {
    background: #58B7D6;
    border-color: #58B7D6;
  }

  .pagination-absolute {
    position: absolute;
    bottom: 0;
    background: #fff;
    width: 95%;
    padding-left: 20px;
    height: 40px;
  }

  /deep/ .el-dialog--center {
    border-radius: 8px !important;
  }

  /deep/ .el-message-box__title {
    color: #409EFF !important;
  }

  /deep/ .el-dialog__title {
    color: #409EFF !important;
  }

</style>





// WEBPACK FOOTER //
// src/views/Marketing/orderFullRedManage.vue